import Box from '@mui/material/Box';
import { getData, isValid } from 'clients/Clients';
import ProductCardNewList from 'components-v2/mocules/ProductCardNewList';
import ListProductWithTitle from 'components/mocules/ListProductWithTitle';
import SliderProductBlock from 'components/mocules/Skeleton/SliderProductBlock';
import { EnumProductsDisplayedMobile } from 'constants/Enums/app-settings';
import { EnumBlockCodeTracking } from 'constants/tracking';
import { useGetProductsDisplayedFromAppSettings } from 'hooks/useGetProductsDisplayedFromAppSettings';
import { useIsInViewportOnce } from 'hooks/useIsInViewportOnce';
import { useState } from 'react';
import { getSortedProducts, moveKcbPriorityFirst } from 'services/ProductService';
import useIsKcbVerified from 'hooks/useIsKcbVerified';
import ProductServiceV2 from 'services/ProductServiceV2';
import styles from './styles.module.css';
import SupplierClient from 'clients/SupplierClient';
import { sellerForStore } from 'utils/StoreUtils';

const NO_VIEW_MORE_SELLER_TYPES = ['INDIVIDUAL', 'MARKET'];

function getSellerURL(seller, sellerCode = '') {
  if (seller?.isStore) {
    return `/seller/${seller?.slug}/list-product`;
  }

  if (seller?.isInternal || !NO_VIEW_MORE_SELLER_TYPES.includes(seller?.sellerType)) {
    return `/seller-products/${seller?.code}/${seller?.sellerType == 'ENTERPRISE' ? seller?.slug : ''}`;
  }

  return `/doitac/${sellerCode}`;
}

export default function ProductsSameSeller({ product, sellerInfo, blockCodeTracking = EnumBlockCodeTracking.PRODUCT_DETAIL_SAME_SELLER }) {
  const isKcbVerified = useIsKcbVerified();
  const [productsBySeller, setProductsBySeller] = useState([]);
  const [loading, setLoading] = useState(true);

  const MAXIMUM_PRODUCTS_SELLER = useGetProductsDisplayedFromAppSettings(EnumProductsDisplayedMobile.PRD_DETAIL_SELLER_PRODUCTS);

  const { elementRef } = useIsInViewportOnce({
    callback: async function fetchProductDetailRecommendation() {
      setLoading(true);
      let listProductBySellerRes;
      if (product?.vendorProductTag) {
        listProductBySellerRes = await ProductServiceV2.loadProductWithTag({
          slug: product?.vendorProductTag,
          offset: 0,
          limit: 15,
          v2: true,
        });
      } else {
        listProductBySellerRes = await ProductServiceV2.loadProductWithSeller({
          code: sellerInfo?.code,
          // SP cùng gian với SKU đang xem (BV-2164): productFilter của gian, seller-core trả sẵn
          storeFilter: sellerInfo?.productFilter,
          offset: 0,
          limit: 15,
          v2: true,
        });
      }
      setLoading(false);

      if (isValid(listProductBySellerRes)) {
        const listProductBySeller = moveKcbPriorityFirst(
          getSortedProducts(
            getData(listProductBySellerRes)
              ?.filter((item) => item?.sku !== product?.sku)
              ?.map((prd) => ({ ...prd, isSameSeller: true })) || [],
          ),
          isKcbVerified,
        );

        const dataWithTracking = listProductBySeller.map((item) => ({ ...item, blockCode: blockCodeTracking }));

        let sellerCodes = [];
        dataWithTracking?.forEach((item) => {
          if (item.seller && item.seller.code) sellerCodes.push(item.seller.code);
        });
        if (sellerCodes.length) {
          sellerCodes = [...new Set(sellerCodes)];
          const sellers = await SupplierClient.getSellersV2(sellerCodes).then(getData);
          const sellersMap = new Map(sellers.map((seller) => [seller.code, seller]));
          dataWithTracking?.forEach((item) => {
            item.sellerInfo = sellerForStore(sellersMap.get(item.seller.code), item.storeCode);
          });
        }

        setProductsBySeller(dataWithTracking);
      }
    },
  });

  return (
    <section className="products-same-seller" ref={elementRef}>
      {loading ? (
        <SliderProductBlock />
      ) : (
        <Box className={styles.containerPage} style={{ marginTop: '20px' }}>
          <ListProductWithTitle
            iconWidth="40px"
            iconHeight="41px"
            name="Sản phẩm cùng nhà bán hàng"
            key="flagship-same-seller"
            viewMore
            redirect={getSellerURL(sellerInfo, product.sellerCode)}
          >
            {productsBySeller.slice(0, MAXIMUM_PRODUCTS_SELLER).map((product, index) => (
              <ProductCardNewList product={product} key={`item-product-${product.slug}`} index={index} />
            ))}
          </ListProductWithTitle>
        </Box>
      )}
    </section>
  );
}
